import logger from "../../utils/LoggerFrontend";

export const ActionsListenersDataViz = ({ Actions, database }) => {
  Actions.loadDataVizCampaignData.listen(function (campaignId) {
    logger.log("Actions:loadDataVizCampaignData DataViz", "Start getting channel campaign IDs", {
      campaignId
    });

    database
      .getCampaignWithId(campaignId)
      .then((campaignData) => {
        if (!campaignData) {
          logger.log("error:Actions:loadCampaignData", "No campaignData found", {
            campaignData,
            campaignId
          });
          return this.failed("Campaign data empty");
        }

        this.completed({ ...campaignData, id: campaignId });
      })
      .catch(this.failed);
  });

  Actions.getDataVizChannelCampaignsByCampaignId.listen(function (campaignId, orgaId) {
    logger.log(
      "Actions:getChannelCampaignsByCampaignId DataViz",
      "Start getting channel campaign IDs",
      {
        campaignId,
        orgaId
      }
    );

    database
      .getChannelCampaignsByCampaignIdAndOrgaId(campaignId, orgaId)
      .then((channelCampagins) => {
        if (!channelCampagins) {
          logger.log("error:Actions:getChannelCampaignsByCampaignId", "No channelCampaigns found", {
            channelCampagins,
            campaignId
          });

          return this.failed("Channel Campaign data empty");
        }

        logger.log("Actions:getChannelCampaignsByCampaignId", "finished", {
          channelCampagins,
          campaignId
        });
        this.completed(channelCampagins);
      })
      .catch(this.failed);
  });

  Actions.getDataVizAdsetsByCampaignId.listen(function (campaignId) {
    logger.log("Actions:getAdsetsByCampaignId DataViz", "called", { campaignId });

    database
      .getAdsetsByCampaignId(campaignId)
      .then((adsets) => {
        if (!adsets) {
          logger.log("error:Actions:getAdsetsByCampaignId", "No adsets found", {
            adsets,
            campaignId
          });

          return this.failed("Campaign has no adsets");
        }

        logger.debug("Actions:getAdsetsByCampaignId", "finished", { adsets });
        this.completed(adsets);
      })
      .catch(this.failed);
  });
};
